import React, { useEffect, useState } from 'react'
import './SalesTimeSheet.css'
import { Col, Row, Table } from 'antd';
import images1 from '../../assets/images1.jfif'
import { BASE_URL, FetchAttendanceTimesheet } from '../../utils/constant';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
import AttachmentModal from '../../common/attachmentsModal';



function SalesTimeSheet({staffData , selectedYearNumber, selectedMonthNumber}) {
    const [timesheetData, setTimesheetData] = useState([]);
    const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [notes, setNotes] = useState();
  
    
    const showAttachmentModal = () => {
      setOpenAttachmentModal(true);
    }
  
    const attachmentsAndNotes = (attachments,notes) => {
      setAttachments(attachments)
      setNotes(notes)
      showAttachmentModal()
    }
    const handleOk = () => {
  
      setOpenAttachmentModal(false);
    };
    const handleCancel = () => {
      setOpenAttachmentModal(false);
    };
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
console.log(staffData)
    useEffect(() => {
        console.log('s')
        getStaffTimesheetList();
      }, [selectedMonthNumber]);

      const getStaffTimesheetList = async () =>{
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchAttendanceTimesheet}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
                "staffId" : staffData?.staffDetail?._id,
     "month" : parseInt(selectedMonthNumber),
     "year" : parseInt(selectedYearNumber)
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('FetchAttendanceTimesheet')
            setTimesheetData(data?.data?.staffAttendanceTracker)
            console.log('setTimesheetData',data.data)
            
      
          
          } else {
            const data = await response.json();
            console.log('stafTodayerr',data)
            // toast.error(data.errorMessage, {
            //   position: toast.POSITION.TOP_RIGHT,
            // });
            
          }
        };
       
        await fetchData();
       
      }
      
    // const maxDays = Math.max(...timesheetData.staffAttendanceTracker.map(({ staffAttendanceTracker }) => staffAttendanceTracker.length));
 console.log('timesheetData.staffAttendanceTracker',timesheetData)
 // Create column definitions dynamically
 const formatDate = (timestamp) => {
    const months = [
      'Jan', 'Feb', 'March', 'April',
      'May', 'June', 'July', 'Aug',
      'Sept', 'Oct', 'Nov', 'Dec'
    ];
  
    const date = new Date(timestamp);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
  
    // Add a zero in front of the day if it's a single digit
    const formattedDay = day < 10 ? `0${day}` : day;
  
    const formattedDate = `${formattedDay} ${month}`;
  
    return formattedDate;
  };
    const disabledData = timesheetData?.map(( item,index ) => ({
        date:formatDate(item.attendanceDate),
        item:item,
        attendance : {absent: item.isAbsent, early:item.isStaffEarly,late:item.isStaffLate,wo:item.isWeeklyOff,
           haldDay: item.isStaffHalfDay,in:item.isStaffIn,out:item.isStaffOut, ot:item.isStaffOverTime,wl:item.isWrongLocation},
        plannedShift : item.shiftDetail,
        inTime: item.checkInTime !== undefined && 
        formatTimeWithAMPM(item.checkInTime) !== undefined ? formatTimeWithAMPM(item.checkInTime) : '---'   ,
        outTime: item.checkOutTime !== undefined && 
        formatTimeWithAMPM(item.checkOutTime) !== undefined ? formatTimeWithAMPM(item.checkOutTime) : '--' ,
        workedHrs: item.totalWorkingHr ?  formatTime(item.totalWorkingHr) : '---'  ,
        olLt: item.staffOtTime ||  item.staffLtTime ? {otTime:item.staffOtTime, ltTime:item.staffLtTime} : '---' 
      }));
     
    const simpleColumns = [

        { headerName: '', field: 'date', pinned:true, width:100, cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          })},
        { headerName: 'Attendance', field: 'attendance',width: '120px', 
        cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }),
        cellRenderer: (params) => {
            console.log(params.data)
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={18} >
              {
                            params.data.attendance.absent == true  ? 
                             <span className='a ml-1 mr-1'>A</span>
                             : 
                            params.data.attendance.in == true  ? 
                             <span className='Ot ml-1 mr-1'>CO</span>
                             : 
                              params.data.attendance.absent == false && params.data?.attendance?.wo == true && params.data?.item?.isStaffOut == false ?
                              <span className='Ot ml-1 mr-1'>WO</span> 
                              :
                              params.data.attendance.absent == false && params.data?.item?.isMinWorkingHr == true ?
                              (
                                <>
                                <span className='a ml-1 mr-1'>A</span>
                                {params.data.attendance.haldDay && <span className='h ml-1 mr-1'>HD</span>}
                                {params.data.attendance.ot && <span className='Ot ml-1 mr-1'>OT</span>}
                                {params.data.attendance.lt && <span className='Ot ml-1 mr-1'>OT</span>}
                                {params.data.attendance.early || params.data.attendance.early ?
                                    <span className='Ot ml-1 mr-1'>WT</span>
                                   : ''
                                 }
                                {params.data.attendance.wl && <span className='Ot ml-1 mr-1'>WL</span>}
                                </>
                               )
                             :(
                              <>
                              <span className='p ml-1 mr-1'>P</span>
                              {params.data.attendance.haldDay && <span className='h ml-1 mr-1'>HD</span>}
                              {params.data.attendance.ot && <span className='Ot ml-1 mr-1'>OT</span>}
                              {params.data.attendance.lt && <span className='Ot ml-1 mr-1'>OT</span>}
                              {params.data.attendance.early || params.data.attendance.early ?
                                  <span className='Ot ml-1 mr-1'>WT</span>
                                 : ''
                               }
                              {params.data.attendance.wl && <span className='Ot ml-1 mr-1'>WL</span>}
                              </>
                             )
                                                      
                            }
              </Col>
            </Row>
          </div>
          </>
            )
            },},
        { headerName: 'Planned Shift', field: 'plannedShift', 
        flex: 1,
        cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }),
        cellRenderer: (params) => {
            console.log(params.data)
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={32} className='text-center'>
                   <div className='text-[13px] leading-[17px]'>
                    <div>{capitalizeFirstLetter(params.data?.plannedShift?.shiftFullName)}</div>
                    <div>{formatTimeWithAMPM(params.data?.plannedShift?.shiftStartTime)} - {formatTimeWithAMPM(params.data?.plannedShift?.shiftEndTime)}</div>
                    <div className='d-flex items-center justify-center'>
                    <p>{formatTime(calculateShiftDuration(params.data?.plannedShift?.shiftStartTime, params.data?.plannedShift?.shiftEndTime))}</p>
                    <span className='mx-2'>-</span>
                    <p>{capitalizeFirstLetter(params.data?.plannedShift?.shiftShortName)}</p>
                    </div>
                   </div>
              </Col>
            </Row>
          </div>
          </>
            )
            }
        },
        { headerName: 'In Time', field: 'inTime',flex: 1, cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }), 
          cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={18} className='text-center ft12'>
                  
              <div  className='ft12'>{params.data?.inTime}</div>
              <div  className='ft12'>{params.data?.item?.checkInTime !== undefined && 
                                     formatTimeWithAMPM(params.data?.item?.checkInTime) !== undefined ? params.data?.item?.checkInLocation ? 
              capitalizeFirstLetter(params.data?.item?.checkInLocationDetail?.locationName2)
            : 'Unknown Location' : '---'}</div>
                    
              </Col>
            </Row>
          </div>
          </>
            )
            }},
        { headerName: 'Out Time', field: 'outTime',flex: 1, cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }),
          cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={18} className='text-center'>
                  
              <div className='text-[13px] leading-none'>{params.data?.outTime}</div>
              <div className='text-[13px] leading-none'>{params.data?.item?.checkOutTime !== undefined && 
                                     formatTimeWithAMPM(params.data?.item?.checkOutTime) !== undefined ? params.data?.item?.checkOutLocation ? 
              capitalizeFirstLetter(params.data?.item?.checkOutLocationDetail?.locationName2)
            : 'Unknown Location' : '---'}</div>
                    
              </Col>
            </Row>
          </div>
          </>
            )
            } },
        { headerName: 'Worked Hrs', field: 'workedHrs',flex: 1, cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize:'13px'
          }), },
        { headerName: 'OT/LT', field: 'olLt',flex: 1, cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize:'13px'
          }),
          cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={18} className='text-center'>
                  
                    <div className='color-green text-[13px]'>{params.data?.item?.isAbsent == false ? 
                    params.data?.olLt?.otTime > 0 ?
                    <p style={{color:"green"}}> {formatTime(params.data?.olLt?.otTime)} </p>
                    :
                    <p style={{color:'red'}}>  {formatTime(params.data?.olLt?.ltTime)} </p>
                    : '---'}
                    </div>
                    
              </Col>
            </Row>
          </div>
          </>
            )
            }
         },
        { headerName: 'Attachments & Notes', field: 'attachments',flex: 1,  cellStyle: () => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }),
          cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <Row>
              <Col sm={18} className='text-center'>
                  
                    <div className=' ft12'>{params.data?.item?.isAbsent == false ? 
                    params.data?.item?.documents?.length > 0 ?
                    <p onClick={() => attachmentsAndNotes(params.data?.item?.documents,params.data?.item?.notes)}> {params.data?.item?.documents?.length} item </p>
                    : '---'
                    :  '---'}
                    </div>
                    
              </Col>
            </Row>
          </div>
          </>
            )
            },},
       
       
    ];
   
    const scroll = { x: 800 };
    function formatTime(milliseconds) {
        if(milliseconds > 0){

            const hours = Math.floor(milliseconds / 3600000);
            const minutes = Math.round((milliseconds % 3600000) / 60000);
            
            if (hours > 0) {
                return `${hours}:${minutes < 10 ? '0' : ''}${minutes} h`;
            } else {
                return `${minutes} m`;
            }
        }
      }
      const calculateShiftDuration = (shiftStartTime, shiftEndTime) => {
        console.log('shiftStartTime',shiftStartTime)
        console.log('shiftEndTime',shiftEndTime)
        const milliseconds_in_a_day = 24 * 60 * 60 * 1000;
        let shiftDuration;
      
        if (shiftStartTime <= shiftEndTime) {
            shiftDuration = shiftEndTime - shiftStartTime;
        } else {
            shiftDuration = milliseconds_in_a_day - shiftStartTime + shiftEndTime;
        }
      
        return shiftDuration;
      }
    function formatTimeWithAMPM(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const minutes = Math.round((milliseconds % 3600000) / 60000);
      
        const formattedHours = hours % 12 || 12;
        const ampm = hours >= 12 ? 'PM' : 'AM';
      
        return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
      }
    
      return (
        <div className='mt-4'>
       
            <div className="ag-theme-alpine text-base border-none font-proxima tableBordered titleCenter [&_.fc-daygrid-day-events]:!bg-red-400">
            <AgGridReact
            className='fw600'
        columnDefs={simpleColumns}
        rowData={disabledData}
        domLayout='autoHeight'
        pagination={true}
        getRowHeight={() => 70}
        paginationPageSize={20}
        paginationPageSizeSelector={false}
      />
    </div>
            {/* <div className='mt-5'>
                <Table className="table-scroll salestimsheet-table mt-5" scroll={scroll} columns={columns} dataSource={data} bordered pagination={false} />
            </div> */}
            <div>
                <Row>
                    {/* <Col sm={6}>
                        <div className='time-last flex justify-between mt-3 mr-1'>
                            <div>
                                <span className='time-r mr-1'>R</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Approved</span>
                            </div>
                            <div>
                                <span className='time1-r mr-1'>R</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Rejected</span>
                            </div>
                            <div>
                                <span className='time2-r mr-1'>R</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Approval awaited</span>
                            </div>
                            <div>
                                <span className='time3-r mr-1'>R</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Applicable for Reg</span>
                            </div>

                        </div>
                    </Col>
                    <Col sm={7}>
                        <div className='time-last flex justify-between mt-3 mr-1'>
                            <div>
                                <span className='time-r mr-1'>OT</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Approved</span>
                            </div>
                            <div>
                                <span className='time1-r mr-1'>OT</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Rejected</span>
                            </div>
                            <div>
                                <span className='time2-r mr-1'>OT</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Approval awaited</span>
                            </div>
                            <div>
                                <span className='time3-r mr-1'>OT</span>
                                <span style={{ fontSize: "7px", marginRight: "1px" }}>Applicable for Reg</span>
                            </div>

                        </div>
                    </Col> */}
                    <Col>
                        <div className='bg-[#E8E8E8] border border-[#929292] flex items-center !p-3 rounded-xl gap-3'>
                            <div>
                                <span className='p mr-1'>P</span>
                                <span className='text-[11px]'>Present</span>
                            </div>
                            <div>
                                <span className='a mr-1'>A</span>
                                <span className='text-[11px]'>Absent</span>
                            </div>
                            <div>
                                <span className='h mr-1'>H</span>
                                <span className='text-[11px]'>Half Day</span>
                            </div>
                            <div>
                                <span className='Ot mr-1'>OT</span>
                                <span className='text-[11px]'>Overtime</span>
                            </div>
                            <div>
                                <span className='Ot mr-1'>LT</span>
                                <span className='text-[11px]'>Less Time</span>
                            </div>
                            <div>
                                <span className='Ot mr-1'>WT</span>
                                <span className='text-[11px]'>Wrong Time</span>
                            </div>
                            <div>
                                <span className='Ot mr-1'>WL</span>
                                <span className='text-[11px]'>Wrong Location</span>
                            </div>
                            <div>
                                <span className='Ot mr-1'>CO</span>
                                <span className='text-[11px]'>Not Clocked-out</span>
                            </div>
                        </div>

                    </Col>
                </Row>
            </div>
            <AttachmentModal
        visible={openAttachmentModal}
        onOk={() => handleOk()}
        onCancel={handleCancel}
        notes={notes}
        attachments={attachments}
      />
        </div>
    )
}

export default SalesTimeSheet